import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { App, Button, Form, Spin, Tabs, Tooltip } from 'antd';
import { QuestionCircleOutlined, WarningTwoTone } from '@ant-design/icons';
import type { TabsProps } from 'antd';
import Types, { routes } from '../../../../../types/types';
import { useAppDispatch, useAppSelector } from '../../../../core/redux';

import { PageHeader } from '../../../../common/components/PageHeader/PageHeader';
import { General } from './General/General';
import { TreatmentCDA } from './TreatmentCDA/TreatmentCDA';
import { TargetShowcase } from './TargetShowcase/TargetShowcase';
import { FormFooterTabs } from '../../../../common/components/FormFooterTabs/FormFooterTabs';
import { projectsApiService } from '../../../../api/projects/projectsApiService';
import { getDataForTargetShowcase, getNormalData, getSavedMaxData } from '../../helpers/helpers';
import { notificationMessages, showNotification } from '../../../usersPage/helpers/helpers';
import { tablesSlice } from '../../TablesSlice';
import { getErrors } from '../../../../helpers/helpers';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import helpTreatmentCda from '../../../../../pdf/help_Обработка_CDA.pdf';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import helpGeneral from '../../../../../pdf/Help_Общее,_целевая_витрина.pdf';

import s from './DocumentProcessing.module.scss';
const { labelNames, initTabs, statusConstants } = Types;

const getOperations = (link) => (
  <Button type={'link'} href={link} target={'_blank'}>
    <QuestionCircleOutlined style={{ fontSize: '20px', color: '#00A899', cursor: 'pointer' }} />
  </Button>
);

const renderAlertIcon = (render) => {
  if (!render) {
    return '';
  }
  return (
    <Tooltip placement='top' title={'Есть несохраненные данные'}>
      <WarningTwoTone twoToneColor={'red'} />
    </Tooltip>
  );
};
const getTabItems = (disabled, form, changes) => {
  const items: TabsProps['items'] = [
    {
      key: initTabs['general'],
      label: <span>Общее {renderAlertIcon(changes[initTabs['general']])}</span>,
      children: (
        <Form form={form} layout='vertical'>
          <General />
        </Form>
      ),
      disabled: false,
    },
    {
      key: initTabs['CDA'],
      label: <span>Обработка CDA {renderAlertIcon(changes[initTabs['CDA']])}</span>,
      children: <TreatmentCDA />,
      disabled: disabled,
    },
    {
      key: initTabs['target_showcase'],
      label: <span>Целевая витрина {renderAlertIcon(changes[initTabs['target_showcase']])}</span>,
      children: <TargetShowcase />,
      disabled: disabled,
    },
  ];

  return items;
};

const tabBarStyle = {
  padding: '0 24px',
  margin: 0,
};
//generalFields ===>
export const russianTitle = 'russianTitle';
export const description = 'description';
export const englishTitle = 'englishTitle';
export const types = 'types';

const generalFields = [russianTitle, description, englishTitle, types];
//====================>

const {
  setEditableTable,
  setMaxData,
  setTargetShowcaseData,
  setDocumentTab,
  setHasUnsavedChanges,
} = tablesSlice.actions;
export const DocumentProcessing = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [currentBtn, setCurrentBtn] = useState('');

  const {
    currentTab,
    editableTable,
    maxData,
    targetShowcaseEditingField,
    hasUnsavedChanges,
    xPathErrors,
    targetShowcaseData: maxTargetShowcaseData,
  } = useAppSelector((state) => state.tablesSlice);
  let link = helpGeneral;
  if (currentTab === 'CDA') {
    link = helpTreatmentCda;
  }

  const [
    saveProjectXPathStructure,
    {
      data: projectXPathStructureData,
      error: projectXPathStructureError,
      isLoading: projectXPathStructureLoading,
      status: projectXPathStructureStatus,
    },
  ] = projectsApiService.useSaveProjectXPathStructureMutation();

  const [
    sendEmail,
    {
      data: sendEmailData,
      error: sendEmailError,
      isLoading: sendEmailLoading,
      status: sendEmailStatus,
    },
  ] = projectsApiService.useSendEmailMutation();

  const [
    addNewProject,
    {
      data: addNewProjectData,
      error: addNewProjectError,
      isLoading: addNewProjectLoading,
      status: addNewProjectStatus,
    },
  ] = projectsApiService.useAddNewProjectMutation();

  const [
    editProject,
    {
      data: editProjectData,
      error: editProjectError,
      isLoading: editProjectLoading,
      status: editProjectStatus,
    },
  ] = projectsApiService.useEditNewProjectMutation();

  const [
    editXPathTargetShowCase,
    {
      data: editXPathTargetShowCaseData,
      error: editXPathTargetShowCaseError,
      isLoading: editXPathTargetShowCaseLoading,
      // status: editXPathTargetShowCaseStatus,
    },
  ] = projectsApiService.useEditXPathTargetShowCaseMutation();
  const [
    getProjectXPathStructure,
    {
      data: getProjectXPathStructureData,
      // isError: projectXPathStructureIsError,
      error: getProjectXPathStructureError,
      // status: getProjectXPathStructureStatus,
      isLoading: getProjectXPathStructureLoading,
    },
  ] = projectsApiService.useGetProjectXPathStructureMutation();

  const [
    getTargetShowcaseData,
    { data: targetShowcaseData, error: targetShowcaseError, isLoading: targetShowcaseLoading },
  ] = projectsApiService.useGetTargetShowcaseDataMutation();
  const onChangeTab = (key: string) => {
    dispatch(setDocumentTab(key));
  };
  const goBack = () => {
    dispatch(setDocumentTab('general'));
    navigate(routes.tableAllProjects);
  };

  const handleSaveTabData = () => {
    switch (currentTab) {
      case initTabs['general']: {
        const errors = [];
        const arrErrors = form.getFieldsError([russianTitle, englishTitle]);
        arrErrors.forEach((el) => {
          if (el.errors.length) errors.push(el.name[0]);
        });
        const fields = form.getFieldsValue(generalFields);
        if (!errors.length) {
          if (editableTable.id) {
            const data = {
              project_name: fields.russianTitle,
              description: fields.description,
              mart_code: fields.englishTitle,
              docs_id: fields.types,
              status: editableTable.status,
              is_ready_to_test: false,
              claim_is_created: false,
            };
            editProject({ data, id: editableTable.id });
          } else {
            const data = {
              data: {
                project_name: fields.russianTitle,
                description: fields.description,
                mart_code: fields.englishTitle,
                status: statusConstants.draft,
                is_ready_to_test: false,
                claim_is_created: false,
              },
              docs_id: fields.types,
            };
            console.log('!editableTable.id data', data);
            addNewProject(data);
          }
        } else {
          showNotification(notification, 'Заполните поля формы', ' ', 'error');
        }

        break;
      }
      case initTabs['CDA']: {
        const hasErrors = xPathErrors.length;
        if (hasErrors) {
          showNotification(notification, 'Заполните поля формы', ' ', 'error');
          return;
        }
        const savedData = getSavedMaxData(maxData);
        saveProjectXPathStructure({ data: savedData, id: editableTable.id });
        break;
      }
      case initTabs['target_showcase']: {
        const err = [];
        const data = maxTargetShowcaseData.map((row) => {
          if (!row.englishName || row.englishName === '-') {
            err.push(labelNames['englishName']);
          }
          if ((!row.xpath || row.xpath === '-') && !row?.args?.length) {
            err.push('xpath');
          }
          if (!row.description || row.description === '-') {
            err.push('Описание обработки');
          }
          const isCastom = row.description === 7;
          return {
            mart_column: {
              code: row.englishName,
              display: row.russianName,
              data_type: row.attributeType,
              order_number: row.number,
              comment: row.comment,
            },
            mart_field_transform: {
              src_code: isCastom ? null : row.xpath,
              transform_idr: row.description,
              args: isCastom ? row.args : [],
              custom_comment: isCastom ? row.customComment : '',
            },
          };
        });
        if (err.length || targetShowcaseEditingField) {
          showNotification(
            notification,
            notificationMessages.errSaveXpath,
            `Заполните обязательные поля ${err.map((field) => `${field}, `)}`,
            'error',
          );
          break;
        }
        editXPathTargetShowCase({ id: editableTable.id, body: data });
        break;
      }
      default: {
        console.log('general');
      }
    }
  };
  const generalInit = { ...hasUnsavedChanges, [initTabs['general']]: false };
  const cdaInit = { ...hasUnsavedChanges, [initTabs['CDA']]: false };
  const targetShowcaseInit = { ...hasUnsavedChanges, [initTabs['target_showcase']]: false };
  const handleResetTabData = () => {
    switch (currentTab) {
      case 'general': {
        if (editableTable.id) {
          form.resetFields();
          // getProgect({ id: editableTable.id });
        } else {
          console.log('none');
        }
        dispatch(setHasUnsavedChanges(generalInit));
        break;
      }
      case 'CDA': {
        getProjectXPathStructure({ id: editableTable.id });
        dispatch(setHasUnsavedChanges(cdaInit));
        break;
      }
      case 'target_showcase': {
        getTargetShowcaseData({ id: editableTable.id });
        dispatch(setHasUnsavedChanges(targetShowcaseInit));
        break;
      }
      default: {
        console.log('general');
      }
    }
  };

  const handleSendEmail = (key) => {
    if (editableTable.id) {
      const docs =
        editableTable.doc_type && typeof editableTable.doc_type[0] === 'object'
          ? editableTable.doc_type.map(({ id }) => id)
          : editableTable.doc_type;

      const data = {
        project_name: editableTable.project_name,
        description: editableTable.description,
        mart_code: editableTable.mart_code,
        docs_id: docs,
        status: statusConstants.active,
        is_ready_to_test: editableTable.is_ready_to_test,
        claim_is_created: editableTable.claim_is_created,
      };
      switch (key) {
        case 'doShowcase': {
          setCurrentBtn('doShowcase');
          data.is_ready_to_test = true;
          data.status = statusConstants.active;
          console.log('doShowcase');
          editProject({ data, id: editableTable.id });
          break;
        }
        case 'application': {
          setCurrentBtn('application');
          data.claim_is_created = true;
          sendEmail({ data, id: editableTable.id });
          break;
        }
        default:
          return;
      }
    }
  };

  const { newProjectError, editProjError, xPathStructureError, editXPTSCError } = getErrors({
    addNewProjectError,
    editProjectError,
    projectXPathStructureError,
    editXPathTargetShowCaseError,
  });

  //success
  useEffect(() => {
    if (
      getProjectXPathStructureData &&
      !getProjectXPathStructureLoading &&
      !getProjectXPathStructureError
    ) {
      const normalData = Array.isArray(getProjectXPathStructureData)
        ? getNormalData(getProjectXPathStructureData)
        : [];
      dispatch(setMaxData(normalData));
    }

    if (getProjectXPathStructureError) {
      showNotification(
        notification,
        notificationMessages.errRespXPathProject,
        xPathStructureError,
        'error',
      );
    }
  }, [
    getProjectXPathStructureData,
    getProjectXPathStructureLoading,
    getProjectXPathStructureError,
  ]);
  useEffect(() => {
    if (targetShowcaseData) {
      const dataSource = getDataForTargetShowcase(targetShowcaseData);
      dispatch(setTargetShowcaseData(dataSource));
    }
  }, [targetShowcaseData, targetShowcaseError, targetShowcaseLoading]);
  useEffect(() => {
    if (
      getProjectXPathStructureData &&
      !getProjectXPathStructureLoading &&
      !getProjectXPathStructureError
    ) {
      const normalData = Array.isArray(getProjectXPathStructureData)
        ? getNormalData(getProjectXPathStructureData)
        : [];
      dispatch(setMaxData(normalData));
    }

    if (getProjectXPathStructureError) {
      showNotification(
        notification,
        notificationMessages.errRespXPathProject,
        xPathStructureError,
        'error',
      );
    }
  }, [
    getProjectXPathStructureData,
    getProjectXPathStructureLoading,
    getProjectXPathStructureError,
  ]);
  useEffect(() => {
    if (targetShowcaseData) {
      const dataSource = getDataForTargetShowcase(targetShowcaseData);
      dispatch(setTargetShowcaseData(dataSource));
    }
  }, [targetShowcaseData, targetShowcaseError, targetShowcaseLoading]);
  useEffect(() => {
    if (
      !projectXPathStructureLoading &&
      projectXPathStructureStatus === 'fulfilled' &&
      projectXPathStructureData
    ) {
      showNotification(notification, notificationMessages.successSave, ' ', 'success');
      dispatch(setHasUnsavedChanges(cdaInit));
    }
  }, [projectXPathStructureLoading, projectXPathStructureStatus, projectXPathStructureData]);
  useEffect(() => {
    if (!addNewProjectLoading && addNewProjectStatus === 'fulfilled' && addNewProjectData) {
      dispatch(setEditableTable({ ...editableTable, ...addNewProjectData }));
      dispatch(setHasUnsavedChanges(generalInit));
      showNotification(notification, notificationMessages.successSave, ' ', 'success');
    }
  }, [addNewProjectLoading, addNewProjectStatus, addNewProjectData]);
  useEffect(() => {
    if (!editProjectLoading && editProjectData && editProjectStatus === 'fulfilled') {
      const fields = form.getFieldsValue(generalFields);
      dispatch(
        setEditableTable({
          ...editableTable,
          project_name: fields.russianTitle,
          description: fields.description,
          mart_code: fields.englishTitle,
          doc_type: fields.types,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          is_ready_to_test: editProjectData.is_ready_to_test,
        }),
      );
      console.log('doShowcase222', editProjectData);

      dispatch(setHasUnsavedChanges(generalInit));
      showNotification(notification, notificationMessages.successSave, ' ', 'success');
    }
  }, [editProjectLoading, editProjectStatus, editProjectData]);

  useEffect(() => {
    if (
      !sendEmailLoading &&
      sendEmailData &&
      sendEmailStatus === 'fulfilled' &&
      currentBtn === 'application'
    ) {
      setCurrentBtn('');
      dispatch(setEditableTable({ ...editableTable, ...sendEmailData }));
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const message = sendEmailData.claim_is_created ? 'отправлена' : 'отклонена';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const icon = sendEmailData.claim_is_created ? 'success' : 'error';
      showNotification(notification, `Заявка на создание витрины ${message}`, ' ', icon);
    }

    if (sendEmailError) {
      showNotification(notification, 'Не удалось создать заявку', ' ', 'error');
    }
  }, [sendEmailLoading, sendEmailStatus, sendEmailData, currentBtn, sendEmailError]);
  useEffect(() => {
    if (
      !editXPathTargetShowCaseLoading &&
      editXPathTargetShowCaseData &&
      !editXPathTargetShowCaseError
    ) {
      showNotification(notification, notificationMessages.successSave, ' ', 'success');
      dispatch(setHasUnsavedChanges(targetShowcaseInit));
    }
  }, [editXPathTargetShowCaseData, editXPathTargetShowCaseError, editXPathTargetShowCaseLoading]);
  //err
  useEffect(() => {
    if (!projectXPathStructureLoading && projectXPathStructureError && !projectXPathStructureData) {
      showNotification(
        notification,
        notificationMessages.errSaveXpath,
        xPathStructureError,
        'error',
      );
    }
  }, [projectXPathStructureLoading, projectXPathStructureStatus, projectXPathStructureData]);
  useEffect(() => {
    if (!projectXPathStructureLoading && projectXPathStructureError && !projectXPathStructureData) {
      showNotification(
        notification,
        notificationMessages.errSaveXpath,
        xPathStructureError,
        'error',
      );
    }
  }, [projectXPathStructureLoading, projectXPathStructureStatus, projectXPathStructureData]);
  useEffect(() => {
    if (!addNewProjectLoading && addNewProjectError && !addNewProjectData) {
      showNotification(notification, notificationMessages.errAddProject, newProjectError, 'error');
    }
  }, [addNewProjectLoading, addNewProjectError, addNewProjectData]);
  useEffect(() => {
    if (!editProjectLoading && editProjectError && !editProjectData) {
      showNotification(notification, notificationMessages.errAddProject, editProjError, 'error');
    }
  }, [editProjectLoading, editProjectError, editProjectData]);
  useEffect(() => {
    if (
      !editXPathTargetShowCaseLoading &&
      !editXPathTargetShowCaseData &&
      editXPathTargetShowCaseError
    ) {
      showNotification(notification, notificationMessages.errAddProject, editXPTSCError, 'error');
    }
  }, [editXPathTargetShowCaseData, editXPathTargetShowCaseError, editXPathTargetShowCaseLoading]);
  const disabledEditableProjectSave = false;
  return (
    <div className={s.DocumentProcessing}>
      <Spin
        tip='Loading...'
        spinning={
          projectXPathStructureLoading ||
          projectXPathStructureLoading ||
          editXPathTargetShowCaseLoading
        }
        size='large'
      >
        <PageHeader
          breadcrumb={[
            { title: <a onClick={goBack}>Все проекты</a> },
            { title: 'Обработка документа' },
          ]}
          goBack={goBack}
          handleSendEmail={handleSendEmail}
          title={editableTable.project_name}
          btns={true}
          checkedDoShowcase={editableTable.is_ready_to_test}
          checkedApplication={editableTable.claim_is_created}
        />

        <Tabs
          tabBarExtraContent={getOperations(link)}
          animated={{ inkBar: true, tabPane: true }}
          rootClassName={s.Tabs}
          tabBarStyle={tabBarStyle}
          defaultActiveKey='general'
          items={getTabItems(!editableTable.id, form, hasUnsavedChanges)}
          onChange={onChangeTab}
          activeKey={currentTab}
        />
      </Spin>

      <div className={s.footer}>
        <FormFooterTabs
          handleSaveTabData={handleSaveTabData}
          handleResetTabData={handleResetTabData}
          disabledSave={disabledEditableProjectSave}
        />
      </div>
    </div>
  );
};
